import { render, staticRenderFns } from "./pdfTemplate.vue?vue&type=template&id=73f174a7&scoped=true"
import script from "./pdfTemplate.vue?vue&type=script&lang=js"
export * from "./pdfTemplate.vue?vue&type=script&lang=js"
import style0 from "./pdfTemplate.vue?vue&type=style&index=0&id=73f174a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f174a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f174a7')) {
      api.createRecord('73f174a7', component.options)
    } else {
      api.reload('73f174a7', component.options)
    }
    module.hot.accept("./pdfTemplate.vue?vue&type=template&id=73f174a7&scoped=true", function () {
      api.rerender('73f174a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/deliveryNote/components/pdfTemplate.vue"
export default component.exports